import {
    borrarDefaultDropDownOptions,
    defaultHeaderDropDown,
    freezeGenericMessage,
} from "../../../common/dataTables/utils";

const dataTableDetalleElement = document.getElementById(
    "dataTablePedimentoDetalle",
);

const columns = [
    {
        id: "material",
        name: "Material",
        sortable: true,
        dropdown: true,
        width: 175,
        align: "left",
    },
    {
        id: "cantidad",
        name: "Cantidad",
        sortable: true,
        dropdown: true,
        width: 150,
    },
    {
        id: "item-selected",
        name: "",
        format: (value) => {
            if (value) {
                return `<span data-item-selected='${value}'></span>`;
            }
            return "";
        },
    },
];

export const dataTableDetalle = new DataTable(dataTableDetalleElement, {
    columns: columns.map((item) => ({ ...dataTableColumnCommonConfiguration, ...item })),
    headerDropdown: defaultHeaderDropDown,
    serialNoColumn: false,
    inlineFilters: true,
    noDataMessage: "Sin mercancías disponibles",
    freezeMessage: freezeGenericMessage,
});

borrarDefaultDropDownOptions(dataTableDetalle);
